module.exports = __webpack_public_path__ + "static/img/tinysite-search.56683f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tinysite-search.png
// module id = xv3+
// module chunks = 208